import api from './api'
import { stringifyPageQuery } from 'services/utils'

export const createFerryService = values => api.post('/ferry-services', values)

export const fetchFerryService = id => api.get(`/ferry-services/${id}`)

export const fetchFerryServicesOfContractor = contractorId =>
  api.get(`/ferry-services?contractorIds=${contractorId}&pageSize=10000&markedAsDeleted=false`)
    .then(page => page.items)

export const fetchAllFerryServices = () =>
  api.get(`/ferry-services?&pageSize=10000&markedAsDeleted=false`)
    .then(page => page.items)

export const fetchFerryServices = params => api.get(`/ferry-services?${stringifyPageQuery(params)}`)

export const updateFerryService = (id, values) => api.put(`/ferry-services/${id}`, values)

export const markFerryServiceAsDeleted = id => api.post(`/ferry-services/${id}/mark-as-deleted`)
